import React, { useState, useEffect } from "react";
import { useAuth } from "../auth/AuthContext";
import { getItemHistory, getNameByOrderId } from "../api/wsApi";

import ImageUpload from "./ImageUpload";
import { useNotification } from "./NotificationContext";
import { amsterdamToday, formatAmsterdamFriendlyDateTime, validateAmsterdamDateInput } from "../utils/time";



function ModalItem({ item, onClick, updateDataItem, fetchData, voorraad = {} }) {
    const [itemData, setItemData] = useState(item);
    const [history, setHistory] = useState([]);
    const [historyExpanded, setHistoryExpanded] = useState(false);


    const auth = useAuth();
    const notification = useNotification();

    useEffect(() => {
        setItemData(item);
        setHistory([]);
        setHistoryExpanded(false);
        if (!item || !item.id) return;
        getItemHistory(item.id)
            .then(setHistory)
            .catch(() => notification("Change history could not be loaded", "error"));
    }, [item]);


    useEffect(() => {
        if (item && item.order_number && item.name && item.name === "00") {
            getNameByOrderId(item.order_number)
                .then((data) => {
                    if (data && data.name) {
                        setItemData({ ...itemData, name: data.name.split(" ").filter((i) => i != '').join(" ") });
                    }
                })
                .catch((err) => {
                    console.log('Error fetching name', err);
                    notification('Naam is niet gevonden', 'error');
                    setItemData({ ...itemData, name: '' });
                });
        }
    }, []);




    const updateDate = (e) => {
        let date = e.target.value;

        if (date.length == 3) {
            if (date[2] != '-') {
                date = date.substring(0, 2) + '-' + date.substring(2);
            } else {
                date = date.substring(0, 2);
            }
        }

        if (date.length == 6) {
            if (date[5] != '-') {
                date = date.substring(0, 5) + '-' + date.substring(5);
            } else {
                date = date.substring(0, 5);
            }
        }
        setItemData({ ...itemData, date: date });
    }

    const formatDate = (date) => `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;

    const dateFromDayAndMonth = (value) => {
        const [day, month] = value.split("-").map(Number);
        const today = amsterdamToday();
        const candidate = new Date(today.getFullYear(), month - 1, day);
        if (candidate.getMonth() !== month - 1 || candidate.getDate() !== day) return null;

        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 2);
        if (candidate < yesterday) {
            candidate.setFullYear(candidate.getFullYear() + 1);
            const daysDiff = Math.floor((candidate - today) / (1000 * 60 * 60 * 24));
            if (daysDiff > 88 && !window.confirm(`${formatDate(candidate)} was ingevuld. Is dit correct? (${daysDiff} dagen)`)) return null;
        }
        return formatDate(candidate);
    };

    const dateFromDay = (value) => {
        const day = Number(value);
        if (!Number.isInteger(day) || day < 1 || day > 31) return null;
        const today = amsterdamToday();
        const candidate = new Date(today.getFullYear(), today.getMonth(), day);
        if (candidate.getMonth() !== today.getMonth()) return null;
        if (today.getDate() > day) candidate.setMonth(candidate.getMonth() + 1);
        if (candidate.getDate() !== day) return null;
        return formatDate(candidate);
    };

    const normalizeDateOnBlur = () => {
        const entered = String(itemData.date ?? "").trim();
        if (entered === "" || entered === "0") {
            setItemData({ ...itemData, date: entered });
            return;
        }
        let normalized = entered;
        if (entered.includes("-")) {
            const parts = entered.split("-");
            if (parts.length === 2) normalized = dateFromDayAndMonth(entered);
        } else {
            normalized = dateFromDay(entered);
        }

        const error = normalized ? validateAmsterdamDateInput(normalized) : null;
        if (!normalized || error) {
            notification(error || "Vul een geldige datum in.", "error");
            setItemData({ ...itemData, date: item.date ?? "0" });
            return;
        }
        setItemData({ ...itemData, date: normalized });
    };

    const updateUa = (e) => {
        setItemData({ ...itemData, ua: e.target.checked });
    }
    const updateName = (e) => {
        setItemData({ ...itemData, name: e.target.value });

        if (e.target.value === "00" && itemData.order_number) {
            getNameByOrderId(itemData.order_number)
                .then((data) => {
                    if (data && data.name) {
                        setItemData({ ...itemData, name: data.name.split(" ").filter((i) => i != '').join(" ") });
                    }
                })
                .catch((err) => {
                    console.log('Error fetching name', err);
                    notification('Naam is niet gevonden', 'error');
                });
        }
    }
    const updateMeter = (e) => {
        setItemData({ ...itemData, meter: e.target.value });
    }
    const updateOrderNumber = (e) => {
        setItemData({ ...itemData, order_number: e.target.value });
    }

    const save = () => {
        if (itemData.date !== item.date) {
            const dateError = validateAmsterdamDateInput(itemData.date);
            if (dateError) {
                notification(dateError, "error");
                return;
            }
        }
        updateDataItem(itemData);
        onClick();
    }


    useEffect(() => {
        if (!item || !item.img_path) return;
        setItemData((currentItem) => ({ ...currentItem, img_path: item.img_path }));
    }, [item]);



    return (
        <div className='modal item-modal' role="dialog" aria-modal="true" aria-label="Artikel bewerken">
            <div className='modal-content item-modal__content'>
                {itemData &&
                    <>
                        <button className="item-modal__dismiss" onClick={onClick} aria-label="Sluiten">×</button>
                        <div className="item-modal__media">
                            {itemData.id ? <ImageUpload itemId={itemData.id} imgPath={itemData.img_path ? "/api/static/img/" + itemData.img_path : '/api/static/landscape-placeholder.svg'} callback={fetchData} /> : <img src='/api/static/landscape-placeholder.svg' alt='placeholder' width={300} height={300} />}
                            <span className={itemData.ua ? "item-modal__status item-modal__status--mobile item-modal__status--muted" : "item-modal__status item-modal__status--mobile"}>{itemData.ua ? "Uit assortiment" : "●  Active"}</span>
                            {itemData.id && <dl className="item-modal__stats" aria-label="Artikelinformatie">
                                <div><dt>Voorraad</dt><dd>{voorraad[itemData.order_number] ?? "—"}</dd></div>
                                <div><dt>Aantal THT-metingen</dt><dd>{itemData.cntTHT ?? 0}</dd></div>
                                <div><dt>Gemiddelde THT</dt><dd>{itemData.cntTHT ? `${Number(itemData.avgTHT || 0).toFixed(1)} d` : "—"}</dd></div>
                                <div><dt>Max. THT</dt><dd>{itemData.cntTHT ? `${itemData.maxTHT ?? 0} d` : "—"}</dd></div>
                            </dl>}
                        </div>

                        <main className="item-modal__body">
                            <div className="item-modal__meta">
                                <span className={itemData.ua ? "item-modal__status item-modal__status--body item-modal__status--muted" : "item-modal__status item-modal__status--body"}>{itemData.ua ? "Uit assortiment" : "●  Active"}</span>
                                {itemData.id && itemData.last_modified && itemData.modified_by &&
                                    <div className="item-modal__changed"><em>Laatst gewijzigd</em><strong>{formatAmsterdamFriendlyDateTime(itemData.last_modified)}</strong><span><i>door </i>{itemData.modified_by}</span></div>
                                }
                            </div>
                            <div className="item-modal__fields">
                                <label className="item-modal__field item-modal__field--wide" htmlFor="name"><span>Naam <b>*</b></span>
                                    <textarea value={itemData.name || ""} onChange={updateName} id="name" {...(!auth.isAdmin() && { disabled: true })} />
                                </label>
                                <label className="item-modal__field" htmlFor="order_number"><span>Artikelnummer <b>*</b></span>
                                    <input value={itemData.order_number || ""} onChange={updateOrderNumber} id="order_number" {...(!auth.isAdmin() && { disabled: true })} />
                                </label>
                                <label className="item-modal__field item-modal__field--meter"><span>Meter</span>
                                <select value={itemData.meter} onChange={updateMeter} {...(!auth.isAdmin() && { disabled: true })}>
                                    {[...Array(17).keys()].map((meter) => {
                                        return <option key={meter + 1} value={meter + 1}>{meter + 1}</option>
                                    }
                                    )}
                                </select>
                                </label>
                                <label className="item-modal__switch"><input type='checkbox' checked={itemData.ua ? true : false} onChange={updateUa} {...(!auth.isAdmin() && { disabled: true })} /><span className="item-modal__switch-ui" /><span>UA</span></label>
                                <label className="item-modal__field item-modal__field--date"><span>Datum <b>*</b></span>
                                <input className="item-modal__date-input" type="tel" inputMode="numeric" value={itemData.date == null ? 0 : itemData.date} onChange={updateDate} onBlur={normalizeDateOnBlur} {...(!auth.isAdmin() && { disabled: true })} />
                                </label>
                            </div>
                        </main>
                        {itemData.id && <section className={`item-history ${historyExpanded ? "item-history--open" : ""}`} aria-label="Wijzigingsgeschiedenis">
                            <button className="item-history-heading" type="button" onClick={() => setHistoryExpanded((expanded) => !expanded)} aria-expanded={historyExpanded}>
                                <h2>Wijzigingsgeschiedenis</h2>
                                <span>{history.length} wijzigingen</span>
                                <i aria-hidden="true">⌄</i>
                            </button>
                            {history.length === 0 ? <p className="item-history-empty">Geen geregistreerde wijzigingen.</p> :
                                <div className="item-history-scroll">
                                    <table>
                                        <thead>
                                            <tr><th>Wanneer</th><th>Van</th><th>Naar</th><th>Door</th></tr>
                                        </thead>
                                        <tbody>
                                            {history.map((change) => <tr key={change.changeId}>
                                                <td>{formatAmsterdamFriendlyDateTime(change.edited_at)}</td>
                                                <td>{change.date || "manco"}</td>
                                                <td>{change.new_date || "manco"}</td>
                                                <td>{change.edited_by || "—"}</td>
                                            </tr>)}
                                        </tbody>
                                    </table>
                                </div>}
                            {history.length > 0 && <div className="item-history-mobile-list">
                                {history.map((change) => <article key={change.changeId}>
                                    <strong>{formatAmsterdamFriendlyDateTime(change.edited_at)}</strong>
                                    <span>{change.date || "manco"} → {change.new_date || "manco"}</span>
                                    <small>{change.edited_by || "—"}</small>
                                </article>)}
                            </div>}
                        </section>}
                        <div className='right item-modal__footer'>
                            <button className='close' onClick={onClick}>Annuleren</button>
                            <button className='save' onClick={save}>Opslaan</button>
                        </div>
                    </>
                }
            </div>
        </div>
    );
}


export default ModalItem;
